"use client";

import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query";
import { apiClient } from "@/lib/api/client";

const MAX_QUERY_RETRIES = 3;

function shouldRetryQuery(failureCount: number): boolean {
  return !apiClient.isSessionDead() && failureCount < MAX_QUERY_RETRIES;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
    },
  },
});

export function QueryProvider({ children }: { children: React.ReactNode }) {
  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
    </TanstackQueryClientProvider>
  );
}
